<template>
  <div class="info-container">
    <div class="row justify-end">
      <q-btn
        round
        dense
        flat
        icon="close"
        color="primary"
        @click="router.back()"
      />
    </div>

    <show-appointment v-if="startDate && !isPaymentCompleted && !showPending" :start-date="startDate" :duration="duration" :rest-betrag="sessionType === 'o' ? undefined :restBetrag"/>

    <div class="column items-center q-mt-md">
      <order-pending v-if="showPending"/>
      <order-sucess v-if="isPaymentCompleted && !showPending" :startDate="startDate" :duration="duration" />

      <pay-component 
      v-else-if="appointmentID != null && !showPending" 
      :appointmentID="appointmentID" 
      :duration="duration" 
      :time="time" 
      :sessionType="sessionType" 
      :rest-betrag="restBetrag" 
      :start-date="startDate" 
      :studio-malbert="studioMalbert"
      :studio-dortmund="studioDortmund"
      @update:is-loading="(val) => isLoading = val"
      />
      
      <div class="row q-mt-md">
        <q-btn
          no-caps
          flat
          size="lg"
          color="primary"
          label="Back"
          icon="arrow_back_ios"
          @click="router.back()"
        />
      </div>
    </div>
  </div>

      <q-btn
      class="row q-mt-md"
          no-caps
          flat
          size="sm"
          color="primary"
          label="Imprint and data protection"
          to="/en/data-protection-imprint"
        />
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import ShowAppointment from '@/components/ShowAppointment.vue';
import PayComponent from '@/components/PayComponent.vue';
import OrderSucess from '@/components/OrderSucess.vue';
import OrderPending from '@/components/OrderPending.vue';
import { doc, onSnapshot, getFirestore } from 'firebase/firestore'
import { ref, computed, onUnmounted } from 'vue'

const router = useRouter()
const route = useRoute()
const appointmentID = route.query.a != null ? String(route.query.a)  : undefined
const startDate = route.query.s != null ? new Date(Number(route.query.s)) : undefined
const duration = route.query.d != null ? Number(route.query.d) : 60
const time = route.query.t != null ? String(route.query.t) : String(Date.now())
const restBetrag = route.query.r != null ? Number(route.query.r) : undefined
const sessionType = route.query.o != null ? String(route.query.o) : 's'
const studio = route.query.studio != null ? String(route.query.studio).trim().toLowerCase() : ''
const studioDortmundParam = route.query.studioDortmund === '1' || route.query.studioDortmund === 'true' || route.query.do === '1' || route.query.do === 'true' || studio === 'dortmund'
const studioMalbert = route.query.m === '1' || route.query.m === 'true' || studio === 'malbert' || studioDortmundParam
const studioDortmund = studioDortmundParam || studioMalbert

const db = getFirestore()

const paymentStatus = ref<string | null>(null)
const isLoading = ref(false)

if (appointmentID && time) {
  const orderRef = doc(db, 'orders-status', `${appointmentID}__${time}`)

  const unsub = onSnapshot(orderRef, (snapshot) => {
    if (snapshot.exists()) {
      paymentStatus.value = snapshot.data().paymentStatus ?? null
    } else {
      paymentStatus.value = null
    }
  })

  onUnmounted(() => unsub())
}

const showPending = computed(() => isLoading.value && !isPaymentCompleted.value)
const isPaymentCompleted = computed(() => paymentStatus.value === 'Completed')
</script>
